import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { QueryKeys } from './query-keys';
// import { bitcoinPriceMockCase } from '../../../test/mock-liq/setup-liq';
/* 
{
  "time": 1736487604,
  "USD": 94127,
  "EUR": 91497,
  "GBP": 76593,
  "CAD": 135844,
  "CHF": 86041,
  "AUD": 151850,
  "JPY": 14913400
}
*/

type BitcoinPriceMempool = {
  time: number;
  USD: number;
};

export function useBitcoinPriceMempool(): UseQueryResult<BitcoinPriceMempool> {
  const path = 'https://mempool.space/api/v1/prices';

  return useQuery({
    queryKey: [QueryKeys.bitcoinPrice],
    queryFn: () => fetch(path).then((res) => res.json()),
    // Refetch every 10 minutes.
    refetchInterval: 10 * 60 * 1000,
    staleTime: 60 * 1000,
  });
}

export function useBitcoinPrice(): UseQueryResult<BitcoinPriceMempool> {
  const path = '/api/bitcoin-price';

  return useQuery({
    queryKey: [QueryKeys.bitcoinPrice],
    // queryFn: () => ({"USD": 107755.10,"time":1753980497}), // Excel sheet example 1.
    // queryFn: () => ({"USD": 90000,"time":1753980497}), 
    // queryFn: () => ({ "USD": bitcoinPriceMockCase, "time": 1753980497 }),

    queryFn: () => fetch(path).then((res) => res.json()),
    // Refetch every 2 minutes.
    refetchInterval: 2 * 60 * 1000,
    staleTime: 2 * 1000,
  });
}
